import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils.js";

export type ProgressProps = HTMLAttributes<HTMLDivElement> & {
  value?: number;
};

export const Progress = ({ className, value = 0, ...props }: ProgressProps) => (
  <div
    className={cn("relative h-2 w-full overflow-hidden rounded-full bg-primary/20", className)}
    {...props}
  >
    <div
      className="h-full bg-primary transition-all"
      style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
    />
  </div>
);
